import { useEffect } from 'react';

const useOutsideClick = (handler, { ref }) => {
  const handleEvent = (e) => {
    if (ref && ref.current && !ref.current.contains(e.target) && handler) {
      handler();
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleEvent, false);
    document.addEventListener('keyup', handleEvent, false);

    return () => {
      document.removeEventListener('keyup', handleEvent, false);
      document.removeEventListener('mouseup', handleEvent, false);
    };
  }, [handler]);
};

export default useOutsideClick;
